import { observable } from "mobx";
import AgendamentoContainerService from "../../../../../services/AgendamentoContainerService";

export default class RetiradaStore {



    @observable booking;
    @observable qtdDisponivel;
    @observable isReefer;
    @observable tiposCntr;

    @observable armador;
    @observable operacao;
    @observable pod;
    @observable destino;

    @observable temperatura;
    @observable ventilacao;
    @observable umidade;
    @observable genset;

    @observable saldo

    constructor() {
        this.booking = [];
        this.qtdDisponivel = [];
        this.isReefer = [];
        this.tiposCntr = [];
        this.tiposCntrVisible = []; 
        this.dadosTipoCntrBooking = [];
        this.dadosTipoCntrBookingVisible = [];

        this.armador = [];
        this.operacao = [];
        this.pod = [];
        this.destino = [];

        this.temperatura = [];
        this.ventilacao = [];
        this.umidade = [];
        this.genset = [];

        this.saldo = [];

        this.atualizaDados = true;
        this.adicionaNovoItemRetirada();
        this.service = new AgendamentoContainerService();
    };

    adicionaNovoItemRetirada = () => {
        this.booking.push([]);
        this.qtdDisponivel.push([]);   
        this.isReefer.push([]);   
        this.tiposCntr.push([]);
        this.tiposCntrVisible.push(false);
        this.dadosTipoCntrBooking.push(false);
        this.dadosTipoCntrBookingVisible.push(false);

        this.armador.push([]);
        this.operacao.push([]);
        this.pod.push([]);
        this.destino.push([]);

        this.temperatura.push([]);
        this.ventilacao.push([]);
        this.umidade.push([]);
        this.genset.push([]);
    };

    removerItemRetirada = (index) => {
        this.booking.splice(index, 1);
        this.qtdDisponivel.splice(index, 1);  
        this.isReefer.splice(index, 1);
        this.tiposCntr.splice(index, 1);
        this.tiposCntrVisible.splice(index, 1);
        this.dadosTipoCntrBooking.splice(index, 1);
        this.dadosTipoCntrBookingVisible.splice(index, 1);

        this.armador.splice(index, 1);
        this.operacao.splice(index, 1);
        this.pod.splice(index, 1);
        this.destino.splice(index, 1);

        this.temperatura.splice(index, 1);
        this.ventilacao.splice(index, 1);
        this.umidade.splice(index, 1);
        this.genset.splice(index, 1);
    };

    carregarDadosBooking = (booking, index, dadosAgendamento, controller, atualizarAgendamento = true) => {
        if(atualizarAgendamento){
            this.armador[index] = null;
            this.operacao[index] = null;
            this.pod[index] = null;
            this.destino[index] = null;
            this.dadosTipoCntrBooking[index] = null;
            _.set(dadosAgendamento, `listaBookings[0].containers[${index}].ArmIdDepot`, null);
            _.set(dadosAgendamento, `listaBookings[0].containers[${index}].VesselvisitId`, null);
            _.set(dadosAgendamento, `listaBookings[0].containers[${index}].QtdRetirada`, null);
            _.set(dadosAgendamento, `listaBookings[0].containers[${index}].ValVent`, null);
            _.set(dadosAgendamento, `listaBookings[0].containers[${index}].ValUmid`, null);
            _.set(dadosAgendamento, `listaBookings[0].containers[${index}].ValTmpIdea`, null);
        }

        if(booking) {
            this.service.buscarDadosPorBookingDepot(booking).then(response => {
                if (response && response.data) {
                    if((response.data.QtdCntr - response.data.QtdDentro) < 1) controller.listaMensagens = ["O booking deve possuir um saldo maior que 0"];
                    else {
                        this.armador[index] = {ArmIdDepot: response.data.ArmId, ApelidoArmador: response.data.ApelidoArmador };
                        this.operacao[index] = {CodViagem: response.data.CodViagem, NavioViagem: response.data.NavioViagem };
                        this.pod[index] = {CodPortoOrig: response.data.CodPortoOrig, DescPortoOrig: response.data.DescPortoOrig };
                        this.destino[index] = {CodPortoDest: response.data.CodPortoDest, DescPortoDest: response.data.DescPortoDest };

                        this.saldo[index] = response.data.QtdCntr - response.data.QtdDentro;
                        
                        _.set(dadosAgendamento, `listaBookings[0].containers[${index}].ArmIdDepot`, response.data.ArmId);
                        _.set(dadosAgendamento, `listaBookings[0].containers[${index}].VesselvisitId`, response.data.CodViagem);   
                    }             
                } else {
                    this.dadosTipoCntrBooking[index] = "Booking não encontrado.";
                }
            }).catch( erro => {
                console.log(erro)
            });
        }
    };

    limparCampos = (dadosAgendamento, index) => {
        _.set(dadosAgendamento, `listaBookings[0].containers[${index}].ArmIdDepot`, null);
        _.set(dadosAgendamento, `listaBookings[0].containers[${index}].VesselvisitId`, null);
        _.set(dadosAgendamento, `listaBookings[0].containers[${index}].QtdRetirada`, null);
        _.set(dadosAgendamento, `listaBookings[0].containers[${index}].ValVent`, null);
        _.set(dadosAgendamento, `listaBookings[0].containers[${index}].ValUmid`, null);
        _.set(dadosAgendamento, `listaBookings[0].containers[${index}].ValTmpIdea`, null);
    }

    carregarTiposCntrPorBooking = (booking, index, dadosAgendamento, atualizarAgendamento = true) => {
        if(atualizarAgendamento) {
            this.tiposCntr[index] = [];
            //this.qtdDisponivel[index] = null;
            //this.isReefer[index] = null;
            _.set(dadosAgendamento, `listaBookings[0].containers[${index}].CdTipoCntr`, null);
            _.set(dadosAgendamento, `listaBookings[0].containers[${index}].ValVent`, null);
            _.set(dadosAgendamento, `listaBookings[0].containers[${index}].ValUmid`, null);
            _.set(dadosAgendamento, `listaBookings[0].containers[${index}].ValTmpIdea`, null);
        }

        if(booking) {
            this.service.buscarTiposCntrPorBookingDepot(booking).then(response => {
                if (response && response.data){
                    this.tiposCntr[index] = response.data;
                    if(response.data.length === 1 && "S" === response.data[0].FlgRefrigCntr){
                        if(atualizarAgendamento) {
                            _.set(dadosAgendamento, `listaBookings[0].containers[${index}].CdTipoCntr`, response.data[0].CodTipoCntr);
                        }
                        //this.qtdDisponivel[index] = response.data[0].Quantidade;
                        //this.isReefer[index] = "S" === response.data[0].FlgRefrigCntr;
                        //this.carregarDadosTipoCntr(response.data[0].BookingCntrId, index);
                    }
                }
            }).catch( erro => {
                this.tiposCntr[index] = [];
            });
        }
    };

    carregarDadosTipoCntr = (bookingCntrId, index) => {
        this.dadosTipoCntrBooking[index] = null;
        if(bookingCntrId) {
            this.service.buscarDadosPorTipoCntrDepot(bookingCntrId).then(response => {
                if (response && response.data && response.data.length > 0){
                    let dadosTemperaturaBooking = "Observações do Armador: ";
                    response.data.map(item => {
                        dadosTemperaturaBooking = dadosTemperaturaBooking.concat(item.ObsCntrMerc ? item.ObsCntrMerc + " " : "Ventilação: " + item.Ventilacao + " / Umidade: " + item.Umidade + " / Temperatura: " + item.TempIdeal + " ");
                    });
                    this.dadosTipoCntrBooking[index] = dadosTemperaturaBooking;
                }
            }).catch( erro => {
                console.log(erro)
            });
        }
    };

}


// WEBPACK FOOTER //
// ./src/modules/agendamento/containers-cadastrar/retirada-containers-depot/stores/RetiradaDepotStore.js